import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';

import { fg } from './Gate';

type LegacyFallback = () => boolean;

const resolveAemFeature = (aemFeature: () => boolean, legacyFallback: LegacyFallback): boolean =>
	fg('townsquare_use_feature_encoding_sdk') ? aemFeature() : legacyFallback();

export const isHomeCrossAppCreateEnabled = (legacyFallback: LegacyFallback): boolean =>
	resolveAemFeature(() => isFeatureEnabled('home', 'home-cross-app-create'), legacyFallback);

export const isHomeDashboardExperienceEnabled = (legacyFallback: LegacyFallback): boolean =>
	resolveAemFeature(() => isFeatureEnabled('home', 'home-dashboard-experience'), legacyFallback);

export const isSlackMsTeamsEnabled = (legacyFallback: LegacyFallback): boolean =>
	resolveAemFeature(
		() => isFeatureEnabled('home', 'home-ms-teams-and-slack-integration'),
		legacyFallback,
	);

export const isCollaborationGraphEnabled = (legacyFallback: LegacyFallback): boolean =>
	resolveAemFeature(
		() => isFeatureEnabled('teamwork-graph-platform', 'collaboration-graph'),
		legacyFallback,
	);

export const isHomeWhereYouWorkEnabled = (legacyFallback: LegacyFallback): boolean =>
	resolveAemFeature(() => isFeatureEnabled('home', 'home-where-you-work'), legacyFallback);

export const isRovoAvailable = (legacyFallback: LegacyFallback): boolean =>
	resolveAemFeature(() => isFeatureEnabled('rovo', 'rovo-ai-app-availability'), legacyFallback);

export const isCypherFlockAvailable = (): boolean =>
	resolveAemFeature(
		() => isFeatureEnabled('teamwork-graph-platform', 'flock'),
		// Fallback to true as we've never guarded this before
		() => true,
	);
